<template>
  <BGModal :shown="dialogShown"
           :title="$t('admin_promotion.add_title')">
    <template #content>
      <v-container class="add-promotion">
        <v-form v-model="isFormValid"
                ref="addPromotionForm">
          <v-row>
            <v-col>
              <v-text-field outlined
                            :label="$t('admin_promotion.name')"
                            v-model="promotion.name"
                            clearable
                            :rules="requiredRules"></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-input :rules="requiredRules"
                       hide-details="auto"
                       v-model="promotion.from_time">
                <v-container fluid class="flex-column">
                  <legend class="v-label theme--light">{{ $t('admin_promotion.from_time') }}</legend>
                  <DateTimePickerInput v-model="promotion.from_time"
                                       hide-details></DateTimePickerInput>
                </v-container>
              </v-input>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-input :rules="requiredRules"
                       hide-details="auto"
                       v-model="promotion.to_time">
                <v-container fluid class="flex-column">
                  <legend class="v-label theme--light">{{ $t('admin_promotion.to_time') }}</legend>
                  <DateTimePickerInput v-model="promotion.to_time"
                                       hide-details></DateTimePickerInput>
                </v-container>
              </v-input>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-input hide-details="auto"
                       v-model="icon"
                       :rules="requiredRules">
                <v-container fluid class="flex-column">
                  <legend class="v-label theme--light">{{ $t('admin_promotion.icon') }}</legend>
                  <PhotoPreviewInput v-model="icon"
                                     div-class="promotion-icon-input"
                                     file-name="promotion-icon"></PhotoPreviewInput>
                  <small class="form-text text-muted">ACCEPTED FILE FORMAT: PNG, JPEG, JPG; RECOMMENDED SIZE: <b>335(W) X 335(H)</b></small>
                </v-container>
              </v-input>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-file-input :label="$t('admin_promotion.content')"
                            accept="image/jpeg, image/png, image/jpg, application/pdf"
                            hint="ACCEPTED FILE FORMAT: PNG, JPEG, JPG, PDF"
                            persistent-hint
                            clearable
                            v-model="content"
                            :rules="requiredRules">
                <template #selection="{file, text}">
                  {{ text || file }}
                </template>
                <template #append-outer>
                  <a :href="getURL(content)"
                     target="_blank"
                     v-if="content">
                    <v-icon>fas fa-search</v-icon>
                  </a>
                </template>
              </v-file-input>
            </v-col>
          </v-row>
        </v-form>
      </v-container>
    </template>
    <template #footer>
      <v-row no-gutters>
        <v-btn @click="cancel"
               class="mr-3"
               depressed
               large>
          {{ $t('cancel') }}
        </v-btn>
        <v-spacer></v-spacer>
        <v-btn color="primary"
               depressed
               large
               @click="$refs.addPromotionForm.validate() && save()">
          {{ $t('save') }}
          <v-icon right>fas fa-check</v-icon>
        </v-btn>
      </v-row>
    </template>
  </BGModal>
</template>
<script>
import BGModal from "@/components/BGModal";
import {ref, watch} from "@vue/composition-api";
import DateTimePickerInput from "@/components/DateTimePickerInput";
import PhotoPreviewInput from "@/components/PhotoPreviewInput";

export default {
  name: 'AddPromotionModal',
  components: {PhotoPreviewInput, DateTimePickerInput, BGModal},
  props: {
    shown: Boolean,
  },
  setup(props, {root, emit}) {
    const dialogShown = ref(props.shown);

    // Init
    watch(() => props.shown, (newValue, oldValue) => {
      if (newValue !== oldValue) {
        dialogShown.value = newValue;

        if (newValue) {
          promotion.value = {};
        }
      }
    });
    const cancel = function () {
      emit('cancel');
    };

    // Form
    const isFormValid = ref(false);

    const promotion = ref({});

    const requiredRules = ref([
      value => !!value || root.$t('register.required_fields'),
    ]);

    const icon = ref(null);
    const content = ref(null);

    const getURL = function (f) {
      if (f instanceof File) {
        return URL.createObjectURL(f);
      } else {
        return 'api/static/' + f;
      }
    };

    const save = async function () {
      root.$callAPI('hkiarace/admin/promotion/create/', {
        ...promotion.value,
        icon: await root.$convertFileToBase64(icon.value),
        content: await root.$convertFileToBase64(content.value),
      }, () => {
        emit('finish');
      });
    }

    return {
      dialogShown,
      cancel,

      isFormValid,
      promotion,

      requiredRules,

      icon,
      content,

      getURL,

      save,
    }
  }
}
</script>

<style lang="less">
.add-promotion {
  .v-input {
    legend {
      font-weight: bold;
    }
  }
}
</style>

